import { render } from "./KdgClientNotifications.vue?vue&type=template&id=da0a25c0&scoped=true&ts=true"
import script from "./KdgClientNotifications.vue?vue&type=script&lang=ts"
export * from "./KdgClientNotifications.vue?vue&type=script&lang=ts"

import "./KdgClientNotifications.vue?vue&type=style&index=0&id=da0a25c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da0a25c0"]])

export default __exports__